import { render, staticRenderFns } from "./ClassesAdd.vue?vue&type=template&id=3d883ee2&"
import script from "./ClassesAdd.vue?vue&type=script&lang=ts&"
export * from "./ClassesAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports